class AskAIToGeneratePageTasks {

  constructor(currentUserBasePath, apiClient) {

    this.userBasePath = `${currentUserBasePath}/ask-ai-to-generate-page-tasks`;
    this.apiClient = apiClient;

  }

}

export default AskAIToGeneratePageTasks;